module.exports = __webpack_public_path__ + "common/components/IconDS22/e774cf4410e82f934efbc7caa0376947.svg";